import { useGetCountersQuery } from './countersApi';
import IncidentCountersView from './IncidentCountersView';
import { loadableOf } from './loadable';

type IncidentCountersProps = {
  now: Date;
};

function IncidentCounters({ now }: IncidentCountersProps): JSX.Element {
  return <IncidentCountersView counters={loadableOf(useGetCountersQuery())} now={now} />;
}

export default IncidentCounters;
